export default __webpack_public_path__ + "static/media/authentication-screen.66dbc0c6.png";